"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _isEmpty = _interopRequireDefault(require("validator/lib/isEmpty"));

var _atomImage = require("@xe/atom-image");

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1bowh0g-0"
})(["display:flex;flex-direction:column;"]);

var InputLabel = _styledComponents["default"].label.withConfig({
  displayName: "InputLabel",
  componentId: "sc-1bowh0g-1"
})(["font-weight:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.labelFontWeight || "normal";
}, function (_ref2) {
  var required = _ref2.required;
  return required ? "\n    &:after {\n      content: \"*\";\n      color: #b30021;\n    }\n  " : null;
});

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-1bowh0g-2"
})(["display:flex;flex-direction:row;align-items:center;"]);

var Input = _styledComponents["default"].input.withConfig({
  displayName: "Input",
  componentId: "sc-1bowh0g-3"
})(["width:100%;border:solid 1px;border-color:", ";border-radius:4px;padding:", ";color:", ";background-color:", ";&:focus{background-color:", ";border-color:", ";}:-webkit-autofill{box-shadow:0 0 0px 1000px #fffde8 inset;}&[type=\"number\"]::-webkit-inner-spin-button{appearance:none;}&[type=\"number\"]::-webkit-outer-spin-button{appearance:none;}&[type=\"number\"]{-moz-appearance:textfield;}"], function (_ref3) {
  var valid = _ref3.valid,
      theme = _ref3.theme;
  return valid === false ? theme.invalidInputBorderColor || "#b30021" : theme.normalInputBorderColor || "#8291af";
}, function (_ref4) {
  var hasDecoration = _ref4.hasDecoration;
  return hasDecoration ? "10px 35px 10px 16px" : "10px 16px";
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.inputTextColor || null;
}, function (_ref6) {
  var valid = _ref6.valid,
      isPrefilled = _ref6.isPrefilled,
      theme = _ref6.theme;
  return isPrefilled ? "#fffde8" : valid === false ? theme.invalidInputBackgroundColor || "#fff6f8" : "unset";
}, function (_ref7) {
  var isPrefilled = _ref7.isPrefilled,
      theme = _ref7.theme;
  return isPrefilled ? "#fffde8" : theme.focusedInputBackgroundColor || "#f2fcff";
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.focusedInputBorderColor || null;
});

var DecorationAligner = _styledComponents["default"].div.withConfig({
  displayName: "DecorationAligner",
  componentId: "sc-1bowh0g-4"
})(["line-height:0;margin-left:-35px;"]);

var ErrorDescription = _styledComponents["default"].div.withConfig({
  displayName: "ErrorDescription",
  componentId: "sc-1bowh0g-5"
})(["color:#b30021;font-size:87.5%;margin:3px 0 20px 0;"]);

var GenericInput = function (_Component) {
  (0, _inheritsLoose2["default"])(GenericInput, _Component);

  function GenericInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.setStateAndTellParent = function (newState, callback) {
      _this.setState(newState, function () {
        if (_this.props.onUpdate) {
          _this.props.onUpdate(_this.state);
        }

        if (callback) {
          callback();
        }
      });
    };

    _this.handleInputChange = function (e) {
      _this.setStateAndTellParent({
        value: e.target.value,
        isPrefilled: false
      }, function () {
        _this.validateField();
      });
    };

    _this.handleWheel = function (e) {
      if (_this.state.isFocused) {
        e.preventDefault();
      }
    };

    _this.handleFocus = function (e) {
      _this.setState({
        isFocused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      _this.setState({
        isFocused: false
      });

      _this.validateField(true);

      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    };

    _this.validateField = function (forceSkipDebounce) {
      if (forceSkipDebounce === void 0) {
        forceSkipDebounce = false;
      }

      var valid;
      var errorMessage;

      if (_this.props.persistCustomErrorMessage && _this.props.validator) {
        var result = _this.props.validator(_this.state.value);

        valid = result.valid;
        errorMessage = result.errorMessage;
      } else if (_this.props.required && (0, _isEmpty["default"])(_this.state.value)) {
        valid = false;
        errorMessage = "This field is required";
      } else if (!(0, _isEmpty["default"])(_this.state.value) && _this.props.validator) {
        var _result = _this.props.validator(_this.state.value);

        valid = _result.valid;
        errorMessage = _result.errorMessage;
      } else {
        valid = true;
        errorMessage = "";
      }

      var delay = valid || forceSkipDebounce ? 0 : _this.props.debounceTime;
      clearTimeout(_this.validationTimeout);
      _this.validationTimeout = window.setTimeout(function () {
        _this.setStateAndTellParent({
          valid: valid,
          errorMessage: errorMessage
        });
      }, delay);
    };

    _this.state = {
      value: _this.props.value || "",
      valid: null,
      errorMessage: _this.props.initialErrorMessage,
      isPrefilled: !!_this.props.value
    };
    _this.validationTimeout = null;
    return _this;
  }

  var _proto = GenericInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.inputType === "number") {
      var inputElement = document.getElementById(this.props.inputId);
      inputElement.addEventListener("wheel", this.handleWheel, {
        passive: false
      });
    }

    if (this.state.isPrefilled) {
      this.validateField(true);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.inputType === "number") {
      var inputElement = document.getElementById(this.props.inputId);
      inputElement.removeEventListener("wheel", this.handleWheel);
    }
  };

  _proto.render = function render() {
    var decoration = null;

    if (this.props.decorationOverride) {
      decoration = this.props.decorationOverride;
    } else if (this.state.valid === true && this.props.showCheckmark) {
      decoration = _react["default"].createElement(_atomImage.CheckmarkIcon, null);
    } else if (this.state.valid === false) {
      decoration = _react["default"].createElement(_atomImage.BlockedIcon, null);
    }

    return _react["default"].createElement(Wrapper, null, _react["default"].createElement("div", {
      style: {
        marginBottom: "8px"
      }
    }, _react["default"].createElement(InputLabel, {
      htmlFor: this.props.inputId,
      required: this.props.required
    }, this.props.labelText)), _react["default"].createElement(InputWrapper, null, _react["default"].createElement(Input, {
      type: this.props.inputType,
      id: this.props.inputId,
      name: this.props.inputName,
      autoComplete: this.props.autoComplete,
      value: this.state.value,
      valid: this.state.valid,
      hasDecoration: !!decoration,
      isPrefilled: this.state.isPrefilled,
      onChange: this.handleInputChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      "aria-invalid": this.state.valid === null ? null : !this.state.valid,
      "aria-required": this.props.required,
      "aria-describedby": this.props.overrideAriaDescribedBy || this.props.inputId + "-errorDescription"
    }), _react["default"].createElement(DecorationAligner, null, decoration)), _react["default"].createElement(ErrorDescription, {
      id: this.props.inputId + "-errorDescription",
      "aria-live": this.props.overrideAriaDescribedBy ? null : "polite",
      "aria-atomic": true
    }, this.state.errorMessage || "\xA0"));
  };

  return GenericInput;
}(_react.Component);

GenericInput.defaultProps = {
  inputType: "text",
  inputId: "genericId",
  inputName: "generic",
  autoComplete: null,
  labelText: "Generic Label",
  onUpdate: null,
  required: false,
  validator: null,
  showCheckmark: false,
  debounceTime: 2000,
  initialErrorMessage: "",
  persistCustomErrorMessage: false,
  overrideAriaDescribedBy: null
};
var _default = GenericInput;
exports["default"] = _default;